import type { MooPayload } from "../types/moo";

/** Receipt identity follows the expense, even when categories/payees precede it. */
export function mooReceiptForAction(payload: MooPayload, index: number) {
  const action = payload.actions?.[index];
  if (action?.kind !== "expense_add") return undefined;
  const receipts = payload.receipts?.length ? payload.receipts : payload.receipt ? [payload.receipt] : [];
  const matched = receipts.find(receipt => receipt.id === action.expense?.requestId);
  if (matched) return matched;
  // Older proposals did not consistently bind request IDs. Use expense order, never action order.
  const ordinal = payload.actions!.slice(0, index).filter(row => row.kind === "expense_add").length;
  return receipts[ordinal];
}
